var utils = require('frontend-controller/lib/utils');

module.exports = {
	extends: [
		'/',
		'templates',
		'mediaManagement',
		'mediaDetailsSummary'
	],

	config: {
		isEnhanced: true
	},

	methods: {
		dataDealer: function(){
			this.model.media = this.getResourceRegisterContent('enhanced');
		}
	}
};